module.exports = __webpack_public_path__ + "static/chrome_icon-cc73698dbb4acfad4f60c5cafafad63d.svg";